import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=369dd66b&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=369dd66b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369dd66b",
  null
  
)

export default component.exports